import { GeometryUtility } from "../../../common/GeometryUtility";

export class SegmentLineItem {

	constructor() {
		this.byuuid = null;
		this.direction = null;
		this.lineName = null;
		this.linePoint = null;
		this.segmentDistance = -1;
		this.segmentStationCount = -1;
		this.segmentTime = -1;
		this.segmentTransferTime = -1;
		this.SEndTime = null;
		this.crsCode="EPSG:4326";
	}

	getPoints()
	{
		let pnts=new Array();
		if(this.linePoint)
		{	
			pnts=GeometryUtility.getPointsEx(this.linePoint);
		}
		return pnts;
	}




	static GetSegmentLineItem(jsonItemObj) {
		let lineItem=null;
		if(jsonItemObj==null)return lineItem;
		lineItem=new SegmentLineItem();

		lineItem.byuuid=jsonItemObj.byuuid;
		lineItem.direction=jsonItemObj.direction;
		lineItem.lineName=jsonItemObj.lineName;
		lineItem.linePoint=jsonItemObj.linePoint;
		lineItem.segmentDistance=jsonItemObj.segmentDistance;
		lineItem.segmentStationCount=jsonItemObj.segmentStationCount;
		lineItem.segmentTime=jsonItemObj.segmentTime;
		lineItem.segmentTransferTime=jsonItemObj.segmentTransferTime;
		lineItem.SEndTime=jsonItemObj.SEndTime;

		return lineItem;
	}

}//end SegmentLineItem

